import { render, staticRenderFns } from "./LeftPrueba.vue?vue&type=template&id=51c59884&"
import script from "./LeftPrueba.vue?vue&type=script&lang=js&"
export * from "./LeftPrueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports